import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.DatePickerRoot),
  () => import('./DatePicker'),
  (DatePicker) => {
    ComponentUtil.binder(Hooks.DatePickerRoot, DatePicker);
  },
);
